import i18n from "i18next";
import * as Yup from "yup";

export const ConsentCheckboxValidation = () => {
  return Yup.boolean()
    .oneOf([true], i18n.t("formFields.consentError", { ns: "formFields" }))
    .required()
    .default(false);
};
